<style lang="scss" scoped>
.module4 {
  .slide-8 {
    background-image: url("../../../assets/module4/slide8/background-01.jpg");
    background-size: cover;
    background-position: center;
    padding-top: 80px;
    padding-left: 80px;
    padding-right: 80px;
    height: calc(100% - 80px);
  }
}
h1 {
  color: #ed8595;
  line-height: 65px;
  font-size: 59px;
  transform: rotate(-2deg);
  margin-bottom: 60px;
}
.drag {
  width: 212px;
  height: 212px;
  background-image: url(../../../assets/module1/slide4/drag_drop.svg);
  background-position: center;
  background-size: 160%;
  background-repeat: no-repeat;
  margin-left: 80px;
  margin-right: 140px;
}
.flex {
  align-items: flex-start;
}
h2 {
  color: #68388c;
  font-size: 45px;
  span {
    color: #ed8595;
  }
}
.left {
  width: 35%;
}
.chars {
  top: 20px;
}
.drag-btns {
  position: absolute;
  left: 700px;
  width: 350px;
  top: 520px;
  text-align: center;
}
.drag-item {
  height: 77px;
  width: 235px;
  background-image: url("../../../assets/module4/slide8/ships.png");
  background-size: 100% 100%;
  font-size: 35px;
  font-family: "Kookycat-FASTcaps";
  color: white;
  line-height: 69px;
  text-align: center;
  touch-action: none;
  position: relative;
  z-index: 10;
  display: inline-block;
  margin-bottom: 15px;
  &:first-of-type {
    transform: translateX(80px) rotate(10deg);
  }
  &:nth-of-type(2) {
    transform: translateX(-80px) rotate(-8deg);
  }
  &:nth-of-type(3) {
    transform: translateX(80px) rotate(11deg);
  }
  &:nth-of-type(4) {
    transform: rotate(-5deg);
  }
}
video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 99999999;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
}
.highfive {
  transition: all 0.2s ease-out;
  width: 307px;
  display: block;
  position: absolute;
  bottom: 300px;
  right: 0px;
  img {
    width: 100%;
    height: auto;
  }
  &:hover {
    transform: scale(1.1);
  }
}
</style>

<template>
  <div class="slide-8">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>

    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 7">
        <h1>
          The next game is a fun way to understand how words can get jumbled up
          when your two lips stop working.
        </h1>
      </div>
    </transition>

    <div class="flex ">
      <transition name="fadeUp" appear>
        <div class="left delay-1" v-show="slideIndex == 7">
          <h2>
            See if you can match the funny mixed up words to the pictures and
            <span>
              say them out loud to yourself.
            </span>
          </h2>
        </div>
      </transition>

      <transition name="fadeUp" appear>
        <div class="drag delay-2" v-show="slideIndex == 7"></div>
      </transition>

      <transition name="fadeUp" appear>
        <div class="flex-1 delay-3" v-show="slideIndex == 7">
          <p>
            From now on if your Grandhero is suddenly not able to form words or
            the words come out all scrambled like in this game, you should
            suspect stroke and call an ambulance on 000.
          </p>
        </div>
      </transition>

      <transition name="fadeUp" appear>
        <img
          src="@/assets/module4/slide8/pictures-01.png"
          class="chars delay-4"
          v-show="slideIndex == 7"
        />
      </transition>
      <transition name="fadeUp" appear>
        <img
          v-show="slideIndex == 7"
          src="@/assets/module4/slide8/boxes-01.png"
          class="chars delay-5"
        />
      </transition>
    </div>
    <transition name="scale" appear>
      <div class="drag-btns delay-6" v-show="slideIndex == 7">
        <div class="drag-item " v-drag data-drop-x="615" data-drop-y="420">
          bezra
        </div>
        <div class="drag-item " v-drag data-drop-x="340" data-drop-y="330">
          ships
        </div>
        <div class="drag-item " v-drag data-drop-x="-344" data-drop-y="237">
          ananas
        </div>
        <div class="drag-item " v-drag data-drop-x="-657" data-drop-y="145">
          rugber
        </div>
      </div>
    </transition>
    <a href="#" class="highfive" @click.prevent="play">
      <transition name="scale" appear>
        <img
          src="@/assets/module1/slide26/high_five.svg"
          v-show="slideIndex == 7"
          class="delay-5"
        />
      </transition>
    </a>
  </div>
</template>

<script>
// import { log } from "../../../utils/log";

export default {
  props: ["slideIndex"],
  data() {
    return {
      points: 0,
      showVid: false
    };
  },
  methods: {
    play() {
      this.showVid = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.showVid = false;
            },
            false
          );
        }
      });
    }
  }
};
</script>
